import { NotificationGroup } from '@progress/kendo-react-notification';
import { Fragment } from 'react';
import { useAppSelector } from '../../redux/store';
import SingleNotification from './SingleNotification';

interface ContainerContentProps {
  children: any;
}

export default function ContainerContent(props: ContainerContentProps) {
  const notification = useAppSelector(state => state.appState.notificationMessage);

  return (
    <Fragment>
      <div>{props.children}</div>
      <NotificationGroup
        style={{
          right: 0,
          bottom: 1,
          alignItems: 'flex-start',
          flexWrap: 'wrap-reverse',
        }}
      >
        {notification
          ?
          <SingleNotification
            key={notification.key}
            text={notification.text}
            style={notification.style}
            timeout={notification.timeout}
          />
          : null}
      </NotificationGroup>
    </Fragment>
  );
}
